<template>
  <td v-html="date"></td>
</template>

<script lang="babel">
import { getDateTimeHtml } from '@/js/date';

export default {
    props: ['content'],
    computed: {
      date() {
        return getDateTimeHtml(this.content);
      },
    }
};
</script>
